import { render, staticRenderFns } from "./UserSign.vue?vue&type=template&id=08c42fb5&scoped=true"
import script from "./UserSign.vue?vue&type=script&lang=js"
export * from "./UserSign.vue?vue&type=script&lang=js"
import style0 from "./UserSign.vue?vue&type=style&index=0&id=08c42fb5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c42fb5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08c42fb5')) {
      api.createRecord('08c42fb5', component.options)
    } else {
      api.reload('08c42fb5', component.options)
    }
    module.hot.accept("./UserSign.vue?vue&type=template&id=08c42fb5&scoped=true", function () {
      api.rerender('08c42fb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserH5/UserSign.vue"
export default component.exports